<script setup>
import { useForm } from "@inertiajs/vue3";

import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VDevider from "@/Shared/VDevider.vue";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";

import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";
import VInputPasswordWithLabel from "@/Shared/Form/VInputPasswordWithLabel.vue";
import VSelectDefaultWithLabel from "@/Shared/Form/VSelectDefaultWithLabel.vue";
import VUploadPorfilePictureWithLabel from "@/Shared/Form/VUploadPorfilePictureWithLabel.vue";
import VModal from "@/Shared/VModal.vue";
import { ref } from "vue";

const props = defineProps({
    user: Object,
    roles: Array,

    urlSubmit: String,
    urlUpdateCreds: String,

    method: String,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);

const title = "Edit Profile";

const form = useForm({
    file_picture: null,
    old_picture: props.user?.picture ?? "",
    staf_id: props.user?.staf_id ?? "",
    name: props.user?.name ?? "",
    salutation: props.user?.salutation ?? "",
    working_address: props.user?.working_address ?? "",
    qualification: props.user?.qualification ?? "",
    roles: props.user?.roles.map((item) => item.id) ?? [],
    status: props.user?.status ?? "",

    email: props.user?.email,
    password_old: "",
    password: "",
    password_confirmation: "",

    _method: props.method,
});

const arrStatus = [
    { id: 1, description: "Active" },
    { id: 0, description: "Non-Active" },
];

const submit = () => {
    form.post(props.urlSubmit, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            emits("onSave", form.value);
            refModal.value.closeModal();
        },
    });
};

const submitCreds = () => {
    form.post(props.urlUpdateCreds, {
        onSuccess: () => {
            formCreds.value.password = "";
            formCreds.value.password_confirmation = "";
        },
    });
};

const cancel = () => {
    emits("onCancel");
};
</script>
<template>
    <VModal ref="refModal" :title="title" size="modal-md" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <VInputWithLabel
                                elId="name"
                                label="Name"
                                type="text"
                                :error="form.errors.name"
                                v-model:value="form.name"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <VInputReadonlyWithLabel
                                label="Roles"
                                :value="
                                    user.roles
                                        ?.map((item) => item.name)
                                        .join(',')
                                "
                            />
                        </div>
                        <div class="col-12">
                            <VInputReadonlyWithLabel
                                elId="status"
                                label="Status"
                                :value="user.status_text"
                            />
                        </div>
                    </div>
                    <VDevider class="my-4" />
                </form>
                <form @submit.prevent="submitCreds">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <VInputWithLabel
                                elId="email"
                                label="Email"
                                type="email"
                                :error="form.errors.email"
                                v-model:value="form.email"
                            />
                        </div>

                        <div class="col-12 mb-3">
                            <VInputPasswordWithLabel
                                elId="password_old"
                                label="Old Password"
                                :error="form.errors.password_old"
                                v-model:value="form.password_old"
                            />
                        </div>

                        <div class="col-12 mb-3">
                            <VInputPasswordWithLabel
                                elId="password"
                                label="New Password"
                                :error="form.errors.password"
                                v-model:value="form.password"
                            />
                        </div>

                        <div class="col-12 mb-3">
                            <VInputPasswordWithLabel
                                elId="password_confirmation"
                                label="New Password Confirmation"
                                :error="form.errors.password_confirmation"
                                v-model:value="form.password_confirmation"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-end">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                :disabled="form.processing"
                                @click="submitCreds"
                            >
                                Change Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <template v-slot:footer>
            <div class="text-end">
                <VButtonSubmit
                    type="button"
                    :isProcessing="form.processing"
                    @onCLickSubmit="submit"
                >
                    Submit
                </VButtonSubmit>
            </div>
        </template>
    </VModal>
</template>
